import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Article, ArticleAccessoriesQuery, ArticleAccessoriesService, ArticleAccessory } from '@lobos/library';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-article-accessories-modal',
  templateUrl: './article-accessories-modal.component.html',
  styleUrls: ['./article-accessories-modal.component.scss'],
})
export class ArticleAccessoriesModalComponent implements OnInit {
  public articleAccessory$: Observable<ArticleAccessory | undefined> | undefined;

  constructor(
    private dialogRef: MatDialogRef<ArticleAccessoriesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: Article,
    private articleAccessoriesService: ArticleAccessoriesService,
    private articleAccessoriesQuery: ArticleAccessoriesQuery,
  ) {}

  public ngOnInit(): void {
    this.articleAccessoriesService.getArticleAccessories(this.data).pipe(take(1)).subscribe();
    this.articleAccessory$ = this.articleAccessoriesQuery.selectEntity(this.data.sArticleID);
  }

  selectArticle(article: Article) {
    this.dialogRef.close({ article });
  }
}
